import React, { useState } from 'react';

import { clock } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { hr24to12 } from '@/helpers/timeFormatter';
import { Capacitor } from '@capacitor/core';
import { InputAdornment, Menu, SvgIcon } from '@material-ui/core';
import { format, intlFormat } from 'date-fns';
import ReactDatePicker from 'react-datepicker';

import { FormInput } from '../Inputs';
import { Blurb } from '../Inputs/Blurb';
import styles from './TimePicker.module.scss';

const isCapacitor = Capacitor.isNativePlatform();

type TimePickerProps = {
	value?: string;
	className?: string;
	error?: string;
	onChange?: (value: string) => void;
	filterDate?: (date: Date) => boolean;
};

export const TimePicker: React.FC<TimePickerProps> = ({
	className,
	value,
	error,
	onChange,
	filterDate,
}) => {
	const [anchorEl, setAnchorEl] = useState<Element | null>(null);
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<FormInput
				inputClassName={classNames([
					isCapacitor && styles['center-date-input'],
				])}
				placeholder="Select time"
				name="date"
				id="date"
				value={value && hr24to12(value)}
				onClick={(e) => {
					setAnchorEl(e.currentTarget);
					setIsOpen(true);
				}}
				// onBlur={handleBlur}
				endAdornment={
					!isCapacitor && (
						<InputAdornment
							position="end"
							className={styles['adornment']}
						>
							<SvgIcon component={clock} />
						</InputAdornment>
					)
				}
				error={!!error}
			/>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}
				open={isOpen}
				onClose={() => {
					setIsOpen(false);
				}}
				classes={{
					list: styles['list'],
				}}
			>
				<ReactDatePicker
					inline
					filterDate={filterDate}
					onChange={(date) => {
						setIsOpen(false);

						if (date) {
							onChange && onChange(format(date, 'HH:mm'));
						}
					}}
					showTimeSelect
					showTimeSelectOnly
					timeIntervals={15}
					selected={
						value ? new Date(`1970-01-01T${value}`) : new Date()
					}
					calendarClassName={styles['react-datepicker-calendar']}
					minTime={new Date(0, 0, 0, 6)}
					maxTime={new Date(0, 0, 0, 23)}
				/>
			</Menu>
			{!!error && <Blurb isError>{error}</Blurb>}
		</>
	);
};
